export const API_ROOT = 'http://localhost:8080/'



// WEBPACK FOOTER //
// ./src/api/config.js